/**
 * Utility functions that help with managing a Google Map
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

/**
 * Calculates and returns a LatLngBounds from the provided place markers
 * @param {Object} maps The Google "Maps" object https://developers.google.com/maps/documentation/javascript/reference
 * @param {Array} placeMarkers The list of place markers, where each place marker should provide a location object
 */
export const getUpdatedBounds = (maps, placeMarkers = []) => {
  let bounds = new maps.LatLngBounds()

  placeMarkers.forEach((placeMarker) => {
    const latlng = placeMarker.location?.latlng || {}

    if (latlng.lat && latlng.lng) {
      const { lat, lng } = latlng
      bounds.extend(new maps.LatLng(lat, lng))
    }
  })

  return bounds
}
